import { render, staticRenderFns } from "./commodityCondimentsModel.vue?vue&type=template&id=9e65013a&"
import script from "./commodityCondimentsModel.vue?vue&type=script&lang=js&"
export * from "./commodityCondimentsModel.vue?vue&type=script&lang=js&"
import style0 from "./commodityCondimentsModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports